import React from 'react';
import { Backdrop, CircularProgress, Typography, Box } from '@mui/material';

/**
 * LoadingOverlay Component
 * Displays a loading overlay with optional message
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the overlay is visible
 * @param {string} props.message - Loading message to display
 * @param {Function} props.onClose - Function to call when the overlay is clicked
 * @param {number} props.opacity - Backdrop opacity (0-1)
 * @returns {React.ReactElement} Loading overlay component
 */
const LoadingOverlay = ({
  open = false,
  message = 'Loading...',
  onClose = null,
  opacity = 0.7,
}) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: (theme) => `rgba(0, 0, 0, ${opacity})`,
        flexDirection: 'column',
      }}
      open={open}
      onClick={onClose}
    >
      <CircularProgress color="primary" size={50} thickness={4} />
      
      {message && (
        <Box mt={2}>
          <Typography variant="h6" component="div">
            {message}
          </Typography>
        </Box>
      )}
    </Backdrop>
  );
};

export default LoadingOverlay;